var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Google_Play",
    "data-name": "Google Play",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 217.61 64.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #5bc9f4;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #a7a9ac;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 50.19,
    y1: 32.21,
    x2: 11.3,
    y2: 32.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fbbc0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9a318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99b1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 40.1,
    y1: 35.9,
    x2: 3.53,
    y2: 72.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef4547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6186d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3.36,
    y1: -8.21,
    x2: 33.22,
    y2: 21.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#279e6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2b9f6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#52b16b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6bbc69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74c169"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.81,
    y: 0.81,
    width: 216,
    height: 62.44,
    rx: 7.38,
    ry: 7.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M209.43,64.05H8.19c-4.52,0-8.19-3.67-8.19-8.19V8.19C0,3.67,3.67,0,8.19,0h201.24c4.52,0,8.19,3.67,8.19,8.19v47.67c0,4.52-3.67,8.19-8.19,8.19ZM8.19,1.62c-3.62,0-6.57,2.95-6.57,6.58v47.67c0,3.62,2.95,6.57,6.57,6.57h201.24c3.62,0,6.57-2.95,6.57-6.57V8.19c0-3.63-2.95-6.58-6.57-6.58H8.19Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.78,35.03c-3.78,0-6.87,2.88-6.87,6.84s3.08,6.84,6.87,6.84,6.87-2.9,6.87-6.84-3.08-6.84-6.87-6.84ZM109.78,46.02c-2.07,0-3.86-1.71-3.86-4.15s1.79-4.15,3.86-4.15,3.86,1.68,3.86,4.15-1.79,4.15-3.86,4.15ZM94.8,35.03c-3.78,0-6.87,2.88-6.87,6.84s3.08,6.84,6.87,6.84,6.87-2.9,6.87-6.84-3.08-6.84-6.87-6.84ZM94.8,46.02c-2.07,0-3.86-1.71-3.86-4.15s1.79-4.15,3.86-4.15,3.86,1.68,3.86,4.15-1.79,4.15-3.86,4.15ZM76.98,37.13v2.9h6.94c-.21,1.63-.75,2.82-1.58,3.65-1.01,1.01-2.59,2.12-5.36,2.12-4.28,0-7.62-3.45-7.62-7.72s3.34-7.72,7.62-7.72c2.31,0,3.99.91,5.23,2.07l2.05-2.05c-1.74-1.66-4.04-2.93-7.28-2.93-5.86,0-10.78,4.77-10.78,10.62s4.92,10.62,10.78,10.62c3.16,0,5.55-1.04,7.41-2.98,1.92-1.92,2.51-4.61,2.51-6.79,0-.67-.05-1.3-.16-1.81h-9.77ZM149.85,39.38c-.57-1.53-2.31-4.35-5.86-4.35s-6.45,2.77-6.45,6.84c0,3.83,2.9,6.84,6.79,6.84,3.14,0,4.95-1.92,5.7-3.03l-2.33-1.55c-.78,1.14-1.84,1.89-3.37,1.89s-2.62-.7-3.32-2.07l9.15-3.78-.31-.78ZM140.52,41.66c-.08-2.64,2.05-3.99,3.58-3.99,1.19,0,2.2.6,2.54,1.45l-6.11,2.54ZM133.09,48.3h3.01v-20.11h-3.01v20.11ZM128.16,36.56h-.1c-.67-.8-1.97-1.53-3.6-1.53-3.42,0-6.56,3.01-6.56,6.87s3.14,6.81,6.56,6.81c1.63,0,2.93-.73,3.6-1.55h.1v.98c0,2.62-1.4,4.02-3.65,4.02-1.84,0-2.98-1.32-3.45-2.44l-2.62,1.09c.75,1.81,2.75,4.04,6.06,4.04,3.52,0,6.5-2.07,6.5-7.13v-12.28h-2.85v1.11ZM124.72,46.02c-2.07,0-3.81-1.74-3.81-4.12s1.74-4.17,3.81-4.17,3.65,1.76,3.65,4.17-1.61,4.12-3.65,4.12ZM163.93,28.19h-7.19v20.11h3v-7.62h4.19c3.33,0,6.6-2.41,6.6-6.24s-3.27-6.24-6.6-6.24ZM164.01,37.88h-4.27v-6.89h4.27c2.24,0,3.52,1.86,3.52,3.45s-1.27,3.45-3.52,3.45ZM182.55,34.99c-2.17,0-4.42.96-5.35,3.08l2.66,1.11c.57-1.11,1.63-1.47,2.74-1.47,1.55,0,3.13.93,3.16,2.59v.21c-.54-.31-1.71-.78-3.13-.78-2.87,0-5.79,1.58-5.79,4.53,0,2.69,2.35,4.42,4.99,4.42,2.02,0,3.13-.91,3.83-1.97h.1v1.55h2.9v-7.71c0-3.57-2.66-5.56-6.1-5.56ZM182.19,46.01c-.98,0-2.35-.49-2.35-1.71,0-1.55,1.71-2.15,3.18-2.15,1.32,0,1.94.28,2.74.67-.23,1.86-1.84,3.18-3.57,3.18ZM199.21,35.43l-3.44,8.72h-.1l-3.57-8.72h-3.23l5.35,12.18-3.05,6.78h3.13l8.25-18.96h-3.34ZM172.18,48.3h3v-20.11h-3v20.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.97,12.18c-.47.49-.74,1.26-.74,2.26v35.54c0,1,.28,1.76.74,2.26l.12.12,19.91-19.91v-.47L17.09,12.07l-.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M43.64,39.09l-6.64-6.64v-.47l6.64-6.64.15.09,7.86,4.47c2.25,1.28,2.25,3.36,0,4.64l-7.86,4.47-.15.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.79,39l-6.79-6.79-20.03,20.03c.74.78,1.96.88,3.34.1l23.48-13.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.79,25.42l-23.48-13.34c-1.38-.78-2.6-.69-3.34.1l20.03,20.03,6.79-6.79Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.93,13.32c-.6-.54-1.4-.88-2.28-.88-1.98,0-3.5,1.63-3.5,3.64s1.52,3.62,3.5,3.62c1.7,0,2.94-.99,3.02-2.55h-2.69v-1.11h4.15c0,3.32-1.77,4.89-4.48,4.89s-4.78-2.17-4.78-4.85,2.09-4.86,4.78-4.86c1.25,0,2.38.48,3.2,1.25l-.92.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.47,11.33v1.19h-4.33v3.02h3.78v1.2h-3.78v2.86h4.46v1.19h-5.74v-9.46h5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.75,11.33v1.21h-2.87v8.25h-1.29v-8.25h-2.87v-1.21h7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.88,11.33v9.46h-1.28v-9.46h1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.59,11.33v1.21h-2.87v8.25h-1.29v-8.25h-2.87v-1.21h7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.6,11.22c2.71,0,4.81,2.17,4.81,4.86s-2.1,4.85-4.81,4.85-4.78-2.17-4.78-4.85,2.09-4.86,4.78-4.86ZM115.6,19.69c1.99,0,3.52-1.61,3.52-3.61s-1.52-3.63-3.52-3.63-3.5,1.62-3.5,3.63,1.52,3.61,3.5,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.96,20.79l-4.31-7.13v7.13h-1.28v-9.46h1.26l4.27,7.07v-7.07h1.28v9.46h-1.22Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.2bef83cf1b986697c5fcd1fb45b47a43.svg";
export { ForwardRef as ReactComponent };